import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'av-intake-loader',
  standalone: true,
  templateUrl: './av-intake-loader.component.html',
  styleUrl: './av-intake-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvIntakeLoaderComponent {}
